
  var _styles = {
  "notice-slider-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "overflow": "hidden",
    "paddingLeft": "0.33333rem",
    "width": "9.36rem",
    "height": "0.85333rem"
  },
  "notice-slider-text-wrapper": {
    "overflow": "hidden",
    "backgroundColor": "rgba(0,0,0,0)",
    "marginLeft": "0.05333rem",
    "flex": 1,
    "height": "0.48rem"
  },
  "notice-slider-text": {
    "fontSize": "0.29333rem",
    "lineHeight": "0.48rem",
    "color": "rgb(153,153,153)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "maxWidth": "8.33333rem"
  }
};



  module.exports = _styles;
  